/**
 * Product Bopis
 * @param {object} opts
 */
function productBopis(opts) {
  const config = {
    dom: {
      product: 'product',
      bopis: 'js-bopis-content',
      icon: 'js-replace-with-inline-svg',
    },
    cls: {
      hide: 'hide',
    },
  };
  const c = __.extend(config, opts);

  // global elements
  const $product = document.getElementById(c.dom.product);
  const $bopisContent = $product.querySelectorAll(`.${c.dom.bopis}`);
  const $bopisIcons = $product.querySelectorAll(`.${c.dom.icon}`);
  const { bopisEnable, bopisStorefrontApiKey } = SDG.Data;

  /**
   * Init
   */
  function init() {
    checkDatalayerForBopis();
  }

  function checkDatalayerForBopis() {
    if (bopisEnable && bopisStorefrontApiKey !== '' && window.dataLayer) {
      $bopisContent.forEach(($bopisElement) => {
        __.removeClass($bopisElement, c.cls.hide);
      });
      $bopisIcons.forEach(($bopisIcon) => {
        fetch($bopisIcon.src)
          .then((data) => data.text())
          .then((data) => {
            $bopisIcon.parentElement.innerHTML = data;
          });
      });
    }
    return false;
  }

  return init();
}

export default productBopis;
